import { Box } from '@mui/material';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import DisplayNumber from '@commons/DisplayNumber';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { calculateChange, calculateColor } from '../utils';

const PreviousCurrentCell = ({
  current,
  previous,
  isIncreasePositive = true,
  isPercentage = false,
  isCurrency = false,
  isClickable = false,
  hasDecimals = false,
}) => {
  const [change, setChange] = useState(null);
  const [color, setColor] = useState(ENUM_COLORS.BLACK);

  useEffect(() => {
    const change = calculateChange(current, previous, isPercentage);
    const color = calculateColor(change, isIncreasePositive);

    setChange(change);
    setColor(color);
  }, [current, previous]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        margin: '0 -12px',
        padding: '0 12px',
        '&:hover': {
          backgroundColor: isClickable ? 'rgba(25, 210, 167, 0.08)' : 'transparent',
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Text font={ENUM_FONTS.H4} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <DisplayNumber
            displayCurrencyCode={isCurrency}
            number={isPercentage ? Math.round(current * 100) / 100 : current}
            withoutDecimals={!isPercentage && !hasDecimals}
          />
          {isPercentage && '%'}
        </Text>
        <Text
          color={ENUM_COLORS.DARK}
          font={ENUM_FONTS.H4}
          style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
        >
          <DisplayNumber
            color={ENUM_COLORS.DARK}
            displayCurrencyCode={isCurrency}
            font={ENUM_FONTS.H4}
            number={isPercentage ? Math.round(previous * 100) / 100 : previous}
            withoutDecimals={!isPercentage && !hasDecimals}
          />
          {isPercentage && '%'}
        </Text>
      </Box>

      {!isNaN(change) && change !== null && (
        <Text
          color={color}
          font={ENUM_FONTS.H4}
          style={{ display: 'flex', alignItems: 'center', margin: '12px' }}
        >
          {change >= 0 && '+'}
          <DisplayNumber
            color={color}
            font={ENUM_FONTS.H4}
            number={change}
            withoutDecimals={false}
          />
          {isPercentage ? i18next.t('ANALYSIS.PERFORMANCE.PTS') : '%'}
        </Text>
      )}
    </Box>
  );
};

export default PreviousCurrentCell;
